export default {
  lang: {
    reset: '리셋',
    search: '필터',
    expand: '확장',
    collapse: '스토우',
  },
};
